type BlogPostPreviewHrefParams = {
  slug: string;
  title?: string | null;
  image?: string | null;
  authorName?: string | null;
  authorAvatar?: string | null;
};

export function getBlogPostPreviewHref({
  slug,
  title,
  image,
  authorName,
  authorAvatar,
}: BlogPostPreviewHrefParams) {
  const params = new URLSearchParams();

  if (title) params.set("title", title);
  if (image) params.set("image", image);
  if (authorName) params.set("authorName", authorName);
  if (authorAvatar) params.set("authorAvatar", authorAvatar);

  const query = params.toString();

  return `/blog/post/${encodeURIComponent(slug)}${query ? `?${query}` : ""}`;
}
